import React, { useState } from "react";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import {
  Facet,
  PagingInfo,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch,
  Results,
  SearchProvider,
  SearchBox,
} from "@elastic/react-search-ui";
import { styled } from "@mui/material";
import ElasticsearchAPIConnector from "@elastic/search-ui-elasticsearch-connector";
import { Layout, MultiCheckboxFacet } from "@elastic/react-search-ui-views";
import type { SearchResult } from "@elastic/search-ui";
import { SearchResultComponent } from "./SearchResultComponent";
import { DateRangeFilter } from "./DateRangeFilter";
// import { ClassNameFilter } from "./ClassNameFilter";
import { ClearFilter } from "./ClearFilter";
// import { QueryDisplay } from "./QueryDisplay";
import { API_KEY, ES_ENDPOINT, SEARCH_INDEX } from "../../utils/environmentVariables";
import CentredCircularProgress from "../../components/common/CentredCircularProgress";
import { getToshiType, viewPath } from "../../utils/routeUtils";

export interface SearchResultComponentProps {
  result: SearchResult;
}

interface MaxContentToProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wasSearched?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  results?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addFilter?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeFilter?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFilter?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearFilters?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchTerm?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortList?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isLoading?: any;
}

const SORT_OPTIONS = [
  {
    name: "relevance",
    value: [],
  },
  {
    name: "created",
    value: [
      {
        field: "created",
        direction: "asc",
      },
    ],
  },
  {
    name: "agent name",
    value: [
      {
        field: "agent_name.keyword",
        direction: "asc",
      },
    ],
  },
];

const SearchBoxContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  maxWidth: "1300px",
  margin: "auto",
});

const Search: React.FC = () => {
  // const [className, setClassName] = React.useState<string>("");

  const [resetSignal, setResetSignal] = useState<number>(0);

  const connector = new ElasticsearchAPIConnector(
    {
      host: ES_ENDPOINT.endsWith("/") ? ES_ENDPOINT : ES_ENDPOINT + "/",
      index: SEARCH_INDEX,
      connectionOptions: {
        // Optional connection options.
        headers: {
          "x-api-key": API_KEY,
          "Content-Type": "application/json",
        },
      },
    },
    (requestBody, requestState) => {
      console.log("postProcess requestBody Call", requestBody); // logging out the requestBody before sending to Elasticsearch
      console.log("postProcess requestState Call", requestState); // logging out the requestState before sending to Elasticsearch
      if (requestState.searchTerm && getToshiType(requestState.searchTerm)) {
        // Redirection
        console.log("redirect for " + getToshiType(requestState.searchTerm));
        window.location.href = viewPath(requestState.searchTerm);
      }
      return requestBody;
    },
  );

  const searchConfig = {
    debug: true,
    apiConnector: connector,
    searchQuery: {
      disjunctiveFacets: [
        "clazz_name.keyword",
        "agent_name.keyword",
        "subtask_type.keyword",
        "model_type.keyword",
        "created",
      ],
      search_fields: {
        title: {},
        description: {},
        notes: {},
        clazz_name: {},
        agent_name: {},
        subtask_type: {},
        model_type: {},
        "arguments.k": {},
        "arguments.v": {},
      },
      result_fields: {
        id: {
          raw: {},
        },
        node_id: {
          raw: {},
        },
        clazz_name: {
          raw: {},
        },
        agent_name: {
          raw: {},
        },
        title: {
          raw: {},
        },
        description: {
          raw: {},
        },
        name: {},
        file_name: {
          raw: {},
        },
        file_size: {
          raw: {},
        },
        created: {
          raw: {},
        },
        subtask_type: {
          raw: {},
        },

        // {k: {raw: {}}, v: {raw: {}}},
      },
      facets: {
        "clazz_name.keyword": {
          type: "value",
        },
        "agent_name.keyword": {
          type: "value",
        },
        "subtask_type.keyword": {
          type: "value",
        },
        "model_type.keyword": {
          type: "value",
        },
      },
    },
    autocompleteQuery: {},
  };

  return (
    <SearchProvider config={searchConfig}>
      <WithSearch
        mapContextToProps={({
          wasSearched,
          results,
          addFilter,
          removeFilter,
          setFilter,
          clearFilters,
          searchTerm,
          filters,
          sortList,
          isLoading,
        }: MaxContentToProps) => ({
          wasSearched,
          results,
          addFilter,
          removeFilter,
          setFilter,
          clearFilters,
          searchTerm,
          filters,
          sortList,
          isLoading,
        })}
      >
        {({ wasSearched, results, addFilter, removeFilter, clearFilters, isLoading, filters }: MaxContentToProps) => {
          return (
            <div>
              <Layout
                header={
                  <SearchBoxContainer>
                    <SearchBox />
                    {/* <QueryDisplay filters={filters} searchTerm={searchTerm} sortList={sortList} />
                    <ClassNameFilter
                      className={className}
                      setClassName={setClassName}
                      setFilter={setFilter}
                      removeFilter={removeFilter}
                    /> */}
                  </SearchBoxContainer>
                }
                sideContent={
                  <div>
                    {wasSearched && (
                      <>
                        <ClearFilter
                          wasSearched={wasSearched}
                          clearFilters={() => {
                            setResetSignal(new Date().getTime());
                            clearFilters();
                          }}
                          // setClassName={setClassName}
                        />
                        <Sorting label={"Sort by"} sortOptions={SORT_OPTIONS} />
                      </>
                    )}
                    <Facet key="2" field={"clazz_name.keyword"} label="class name" view={MultiCheckboxFacet} />
                    {wasSearched && (
                      <DateRangeFilter
                        addFilter={addFilter}
                        removeFilter={removeFilter}
                        filters={filters}
                        resetSignal={resetSignal}
                      />
                    )}
                    {/* <Facet key="5" field={"created"} label="created" /> */}
                    <Facet key="1" field={"agent_name.keyword"} label="agent name" />
                    <Facet key="3" field={"subtask_type.keyword"} label="subtask" isFilterable />
                    <Facet key="4" field={"model_type.keyword"} label="model type" />
                  </div>
                }
                bodyHeader={
                  <React.Fragment>
                    {wasSearched && <PagingInfo />}
                    {wasSearched && <ResultsPerPage />}
                  </React.Fragment>
                }
                bodyContent={
                  <>
                    {isLoading && wasSearched ? (
                      <CentredCircularProgress />
                    ) : (
                      results && <Results resultView={SearchResultComponent} />
                    )}
                  </>
                }
                bodyFooter={<Paging />}
              />
              {!wasSearched && isLoading && <CentredCircularProgress />}
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
};

export default Search;
